import { Badge } from 'components/Badge'

export function Changed() {
  return <Badge color="orange" label="Alterado" />
}
